import { Disclosure } from "@headlessui/react";
import {
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import {
  ChartPieIcon,
  HomeIcon,
  PresentationChartBarIcon,
  BanknotesIcon,
  LightBulbIcon,
  FunnelIcon,
  UserGroupIcon,
  ChartBarSquareIcon,
  RocketLaunchIcon,
  CpuChipIcon,
  PaperAirplaneIcon,
  ShieldCheckIcon,
  Squares2X2Icon,
  Cog6ToothIcon,
  CogIcon,
  ViewfinderCircleIcon,
  InformationCircleIcon,
  BuildingOfficeIcon,
  PresentationChartLineIcon,
  StopCircleIcon,
  ArrowPathRoundedSquareIcon,
  CodeBracketSquareIcon,
  ClipboardDocumentCheckIcon,
  ChartBarIcon,
  BookmarkSquareIcon,
  VideoCameraIcon,
  ChevronDoubleLeftIcon,
  QuestionMarkCircleIcon,
  BoltIcon,
  BookOpenIcon,
  CircleStackIcon,
  MicrophoneIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/outline";
import { Search as SearchIcon } from "lucide-react";

import { NavLink, useNavigate } from "react-router-dom";
import { ClassNames } from "../../helper";
import { useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

const navigationObj = [
  { name: "Dashboard", href: "", icon: HomeIcon, current: true, associatedRoutes: [] },
  {
    name: "Marketing performance",
    icon: PresentationChartBarIcon,
    current: false,
    associatedRoutes: ["marketing", "content", "traffic", "ads-leakage", "Google-Analytics", "Ads-Offline-Conversion", "blog-update"],
    children: [
      {
        name: "Ads campaign performance",
        href: "marketing",
        current: false,
        icon: BanknotesIcon,
      },
      {
        name: "Content performance",
        href: "content",
        current: false,
        icon: ChartPieIcon,
      },
      {
        name: "Traffic sources",
        href: "traffic",
        current: false,
        icon: UserGroupIcon,
      },
      {
        name: "Ads leakage",
        href: "ads-leakage",
        current: false,
        icon: FunnelIcon,
      },
      {
        name: "Google Analytics",
        href: "Google-Analytics",
        current: false,
        icon: ChartBarIcon ,
      },
       {
        name: "Ads-Offline Conversion",
        href: "Ads-Offline-Conversion",
        current: false,
        icon: BookmarkSquareIcon ,
      },
      {
        name: "Blog Update",
        href: "blog-update",
        current: false,
        icon: PresentationChartBarIcon,
      },
      {
        name: "SEO Funnel",
        href: "seo-funnel",
        current: false,
        icon: ChartPieIcon,
      },
    ],
  },
  {
    name: "Traffic optimization",
    current: false,
    icon: PresentationChartLineIcon,
    associatedRoutes: ["goals", "abtest","heatmap", "session-replay","personas","bandit-test","custom-nudge","landing-optimization"],
    children: [
      // {
      //   name: "A/B Testing",
      //   href: "abtest",
      //   current: false,
      //   icon: CodeBracketSquareIcon,
      // },
      {
        name: "A/B Test",
        href: "goals",
        current: false,
        icon: StopCircleIcon,
        associatedRoutes: ["abtest", "dashboard","personas","bandit-test","custom-nudge","landing-optimization"],
      },
      // {
      //   name: "Design Your Segments",
      //   href: "bandit-test",
      //   current: false,
      //   icon: CodeBracketSquareIcon,
      // },
      // {
      //   name: "User Segment Statistics",
      //   href: "heatmap",
      //   current: false,
      //   icon: LightBulbIcon,
      // },
        {
          name: "Funnel Analysis",
          href: "heatmap",
          current: false,
          icon: LightBulbIcon,
        },
        {
          name: "User Session Replay",
          href: "session-replay",
          current: false,
          icon: VideoCameraIcon,
      },
    ],
  },
  {
    name: "GEO Tracker",
    icon: ViewfinderCircleIcon,
    current: false,
    associatedRoutes: ["geo"],
    children: [
      {
        name: "Projects",
        href: "geo",
        current: false,
        icon: Squares2X2Icon,
      },
      {
        name: "Domain Scan",
        href: "geo/domain-scan",
        current: false,
        icon: SearchIcon,
      },
      {
        name: "Prompts",
        href: "geo/prompts",
        current: false,
        icon: ClipboardDocumentCheckIcon,
      },
      {
        name: "Runs",
        href: "geo/runs",
        current: false,
        icon: ArrowPathRoundedSquareIcon,
      },
      {
        name: "Analytics",
        href: "geo/analytics",
        current: false,
        icon: ChartBarIcon,
      },
    ],
  },
  {
    name: "Conversation AI",
    icon: CpuChipIcon,
    current: false,
    associatedRoutes: ["chatbot", "automation", "forms"],
    children: [
      {
        name: "Chats",
        href: "chatbot",
        current: false,
        icon: ChatBubbleOvalLeftEllipsisIcon,
      },
      {
        name: "Knowledge Base",
        href: "automation/knowledge-base",
        current: false,
        icon: BookOpenIcon,
      },
      {
        name: "Bots Automation",
        href: "automation",
        current: false,
        icon: MicrophoneIcon,
        associatedRoutes: ["automation/workflows"],
      },
      {
        name: "Forms",
        href: "forms",
        current: false,
        icon: RectangleStackIcon,
        associatedRoutes: ["forms/create", "forms/edit"],
      },
    ],
  },
  {
    name: "Booking Platform",
    icon: RocketLaunchIcon,
    current: false,
    associatedRoutes: ["booking"],
    children: [
      {
        name: "Booking Calendar",
        href: "booking/user-details",
        current: false,
        icon: UserGroupIcon,
      },
      {
        name: "Booking Statistics",
        href: "booking/stats",
        current: false,
        icon: ChartBarSquareIcon,
      },
      {
        name: "Products & Availability",
        href: "booking/products",
        current: false,
        icon: ClipboardDocumentCheckIcon,
      },
      {
        name: "Platform Settings",
        href: "booking/platform-settings",
        current: false,
        icon: CogIcon,
      },
    ],
  },
  // {
  //   name: "Automation",
  //   icon: BoltIcon,
  //   current: false,
  //   associatedRoutes: ["automation"],
  //   children: [
  //     {
  //       name: "Knowledge Base",
  //       href: "automation/knowledge-base",
  //       current: false,
  //       icon: BookOpenIcon,
  //     },
  //     {
  //       name: "Workflows",
  //       href: "automation/workflows",
  //       current: false,
  //       icon: CircleStackIcon,
  //     },
  //   ],
  // },
  {
    name: "Settings",
    icon: Cog6ToothIcon,
    current: false,
    associatedRoutes: ["settings", "change-password", "integration", "help"],
    children: [
      {
        name: "Admin view",
        href: "settings",
        current: false,
        icon: ViewfinderCircleIcon,
      },
      {
        name: "Change password",
        href: "change-password",
        current: false,
        icon: ShieldCheckIcon,
      },
      {
        name: "Integrations",
        href: "integration",
        current: false,
        icon: Squares2X2Icon,
      },
      {
        name: "Help",
        href: "help",
        current: false,
        icon: InformationCircleIcon,
      },
    ],
  },
];

export default function NewSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [navigation, setNavigation] = useState(navigationObj);

  const handleSetRouteActive = useCallback((data, subRoute) => {
    return data.map((item) => {
      if (item.children) {
        let subRouteData = handleSetRouteActive(item.children, subRoute);
        let isSubRouteExists = subRouteData.some((item) => item.current);
        
        // Check if parent's associatedRoutes match the current route
        const isParentRouteMatch = item.associatedRoutes && 
          item.associatedRoutes.some(route => subRoute.startsWith(route));
        
        let res_data;
        if (isSubRouteExists || isParentRouteMatch) {
          res_data = { ...item, current: true, children: subRouteData };
        } else {
          res_data = { ...item, current: false, children: subRouteData };
        }
        return res_data;
      } else {
        // Check if route matches exactly OR if it's in the associated routes
        const isCurrentRoute = item.href === subRoute || 
          (item.associatedRoutes && item.associatedRoutes.some(route => subRoute.startsWith(route)));
        
        return {
          ...item,
          current: isCurrentRoute,
        };
      }
    });
  }, []);

  useEffect(() => {
    let subRoute = location.pathname.slice(1);
    setNavigation((prev) => handleSetRouteActive(prev, subRoute));
  }, [location.pathname, handleSetRouteActive]);

  return (
<div className={ClassNames(
  "flex flex-col h-full overflow-y-auto overflow-x-hidden bg-black dark:from-neutral-900 transition-all duration-300 ease-in-out shadow-xl",
  isSidebarOpen ? "!w-72" : "!w-20"
)}>
      <nav className="flex flex-1 flex-col px-3 py-4">
        <ul className="flex flex-1 flex-col gap-y-2">
          <li>
            <ul className="space-y-1.5">
              {navigation?.map((item) => (
                <li key={item.name}>
                  {!item.children ? (
                    <NavLink
                      to={item.href}
                      end
                      title={item.name}
                      onClick={(e) => {
                        if (!isSidebarOpen) {
                          e.preventDefault();
                          setIsSidebarOpen(true);
                          setTimeout(() => {
                            navigate(item.href);
                          }, 300);
                        }
                      }}
                      className={ClassNames(
                        item.current
                          ? "bg-gradient-to-r from-blue-600 to-blue-700 shadow-lg shadow-blue-500/30 text-white scale-[1.02]"
                          : "hover:bg-white/10 text-gray-300 hover:text-white hover:translate-x-1",
                        "group flex items-center gap-x-3 rounded-xl p-3 text-sm font-medium transition-all duration-200 relative overflow-hidden",
                        !isSidebarOpen && "justify-center"
                      )}
                    >
                      <item.icon
                        className={ClassNames(
                          "h-6 w-6 shrink-0 transition-all duration-200",
                          item.current ? "text-white" : "text-gray-400 group-hover:text-blue-400"
                        )}
                        aria-hidden="true"
                      />
                      {isSidebarOpen && (
                        <span className="truncate">{item.name}</span>
                      )}
                      {item.current && isSidebarOpen && (
                        <div className="absolute right-2 w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                      )}
                    </NavLink>
                  ) : (
                    <Disclosure key={`${item.name}-${item.current}`} defaultOpen={item.current && isSidebarOpen}>
                      {({ open }) => (
                        <>
                          {!isSidebarOpen ? (
                            <button
                              onClick={() => {
                                setIsSidebarOpen(true);
                                if (item.children && item.children.length > 0) {
                                  setTimeout(() => {
                                    navigate(item.children[0].href);
                                  }, 300);
                                }
                              }}
                              className={ClassNames(
                                item.current
                                  ? "bg-gradient-to-r from-blue-600/20 to-blue-700/20 text-white"
                                  : "hover:bg-white/10 text-gray-300 hover:text-white",
                                "flex items-center w-full text-left rounded-xl p-3 gap-x-3 text-sm font-medium transition-all duration-200 group justify-center"
                              )}
                            >
                              <item.icon
                                className={ClassNames(
                                  "h-6 w-6 shrink-0 transition-all duration-200",
                                  item.current ? "text-blue-400" : "text-gray-400 group-hover:text-blue-400"
                                )}
                                aria-hidden="true"
                                title={item.name}
                              />
                            </button>
                          ) : (
                            <Disclosure.Button
                              className={ClassNames(
                                item.current
                                  ? "bg-gradient-to-r from-blue-600/20 to-blue-700/20 text-white"
                                  : "hover:bg-white/10 text-gray-300 hover:text-white",
                                "flex items-center w-full text-left rounded-xl p-3 gap-x-3 text-sm font-medium transition-all duration-200 group"
                              )}
                            >
                              <item.icon
                                className={ClassNames(
                                  "h-6 w-6 shrink-0 transition-all duration-200",
                                  item.current ? "text-blue-400" : "text-gray-400 group-hover:text-blue-400"
                                )}
                                aria-hidden="true"
                                title={item.name}
                              />
                              {isSidebarOpen && (
                                <>
                                  <span className="flex-1 truncate">{item.name}</span>
                                  <ChevronRightIcon
                                    className={ClassNames(
                                      "h-5 w-5 shrink-0 transition-transform duration-200",
                                      open ? "rotate-90 text-blue-400" : "text-gray-500 group-hover:text-gray-400"
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </Disclosure.Button>
                          )}
                          {isSidebarOpen && (
                            <Disclosure.Panel as="ul" className="mt-1.5 ml-3 space-y-1 pl-4">
                              {item.children.map((subItem) => (
                                <li key={subItem.name}>
                                  <NavLink
                                    to={subItem.href}
                                    end
                                    title={subItem.name}
                                    className={ClassNames(
                                      subItem.current
                                        ? "bg-gradient-to-r from-blue-600 to-blue-700 shadow-md shadow-blue-500/20 text-white"
                                        : "hover:bg-white/5 text-gray-400 hover:text-white",
                                      "flex items-center rounded-lg py-2.5 px-3 text-xs font-medium gap-2 transition-all duration-200 hover:translate-x-1"
                                    )}
                                  >
                                    {subItem.icon && (
                                      <subItem.icon
                                        className={ClassNames(
                                          "h-5 w-5 shrink-0 transition-colors",
                                          subItem.current ? "text-white" : "text-gray-500 group-hover:text-blue-400"
                                        )}
                                        aria-hidden="true"
                                      />
                                    )}
                                    <span className="truncate">{subItem.name}</span>
                                  </NavLink>
                                </li>
                              ))}
                            </Disclosure.Panel>
                          )}
                        </>
                      )}
                    </Disclosure>
                  )}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>

      {/* Collapse Toggle Button - Now at Bottom */}
      <div className={ClassNames(
        "sticky bottom-0 z-10 backdrop-blur-md bg-[#172b4d]/80 border-t border-white/10 transition-all duration-300",
        isSidebarOpen ? "px-5 py-3" : "px-0 py-3"
      )}>
        <div className={ClassNames(
          "flex items-center",
          isSidebarOpen ? "justify-end" : "justify-center"
        )}>
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-1.5 rounded-lg hover:bg-white/10 active:bg-white/5 transition-all duration-200 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-blue-400/50"
            title={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          >
            {isSidebarOpen ? (
              <ChevronDoubleLeftIcon className="h-5 w-5 text-gray-300 hover:text-white transition-colors" />
            ) : (
              <ChevronRightIcon className="h-5 w-5 text-gray-300 hover:text-white transition-colors" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}